import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import eventsAssetCenterReducer from '../reducers/eventsAssetCenterReducer';

const configureStore = (railsProps) => (
  createStore(eventsAssetCenterReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
